import Button from '@components/Button';
import { useClose } from '@headlessui/react';
import { PlusSmIcon } from '@heroicons/react/outline';
import { useModalDispatch } from '@hooks/useModalProvider';
import { MODALS } from '@src/constants';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

interface CreateEndorsementButtonProps {
  className?: string;
  isDisabled?: boolean;
}

export const CreateEndorsementButton = ({ className, isDisabled }: CreateEndorsementButtonProps) => {
  const { showModal } = useModalDispatch();
  const closePopover = useClose();

  const handleButtonClick = () => {
    closePopover();
    showModal(MODALS.CREATE_ENDORSEMENT, {});
  };

  return (
    <Button
      className={twMerge(clsx('text-primary-600 flex h-9 justify-start', className))}
      isDisabled={isDisabled}
      onClick={handleButtonClick}
      size="sm"
      data-testid="create-endorsement-button"
    >
      <PlusSmIcon className="text-primary-600 h-5 w-5" />
      Create endorsement
    </Button>
  );
};
